<template src="./List.html">
</template>

<script>
import moment from 'moment'
export default {
  name: "List",
  props: {
    renew: {
      type: Function
    },
    assign: {
      type: Function
    },
    account: {
      type: Boolean
    },
    plan : {
      type: Boolean
    },
    product: {
      type: Boolean
    },

    title: {
      type: String
    },
    pagination: {
      type: Boolean
    },
    search: {
      type: Boolean
    },
    button: {
      type: String
    },
    items: {
      type: Array
    },
    fields: {
      type: Array
    },
    filterOn: {
      type: Array
    },
    filter: null,
    createLink: {
      type: String
    },
    currentPage: {
      type: Number
    },
    summary: {
      type: Boolean
    },
    section: {
      type: String
    },
    accountName: {
      type: String
    },
    redo: {
      type: String
    },
    isAdmin: {
      type: Boolean
    },
    sortCompare: {
      type: Function
    }
  },
  data() {
    return {
      keyword: "",
      perPage: 10,
      pageOptions: [5, 10, 15],
      filteredRowCount: null,
    }
  },
  methods: {
    onFiltered(filteredItems) {
        if (filteredItems){
            this.filteredRowCount = filteredItems.length;
        }
    },
    formatDate(data) {
      return moment.utc(data.value).format(this.$t('DateFormat'))
    }
  },
  computed: {
      getTotalRows:{
        get() {
            if (this.filteredRowCount) {
                return this.filteredRowCount;
            }
            else {
                return this.items.length;
            }
        }
      },
      setCurrentPage: {
          get() { return this.currentPage ? this.currentPage : '' },
          set(setCurrentPage) {this.$emit('input', setCurrentPage)}
      },
      setFilter: {
          get() { return this.filter ? this.filter : '' },
          set(setFilter) {this.$emit('change', setFilter)}
      }
  }
}
</script>
